// A response can carry ACCOUNT_DEACTIVATED at any point in an authenticated session (US-112329:
// "deactivation while a session is active" — the next authenticated request must force a
// logout+redirect). client.ts (lib) can't import the auth feature's error-code constant across
// the boundary, so it emits this generic, feature-agnostic signal instead; <AppShell> (which owns
// the equivalent onIdle-style logout side effect) subscribes to it.
type Listener = () => void;
const listeners = new Set<Listener>();

export function onForceLogout(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function emitForceLogout(): void {
  listeners.forEach((listener) => listener());
}
